<template>
  <div class="wrapper">
    <div class="bgc">
      <div class="shop-container">
        <div class="nav-bread">
          <router-link to="/">{{ $t("home") }}</router-link>
          <span>></span>
          <router-link :to="{ name: 'exam' }">{{ $t("exam") }}</router-link>
          <span>></span>
          <router-link :to="{ name: 'examitem', params: { id: examId } }">{{ topTitle }}</router-link>
          <span>></span>
          <span>{{ "错题列表" }}</span>
        </div>
        <!-- <div class="exam-box" v-loading="loading"> -->

        <xiCheck
          v-if="questionList.length > 0 && chooseId"
          @confrimAll="confrimAll"
          @checkOption="checkOption"
          @starOption="starOption"
          :chooseId="chooseId"
          :questionList="questionList"
          :modelNumber="model"
        ></xiCheck>
        <!-- </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import xiCheck from "@/components/xi-check-start/xi-check-start.vue";
export default {
  components: { xiCheck },
  data() {
    return {
      loading: false,
      topTitle: "详情",
      examId: "",
      timestamp: 86400,
      showAnswerNumber: false,
      pushStatus: 1,
      questionList: [],
      paper_id: 0,
      chooseId: 0,
      model: 4, //1错题，4收藏
    };
  },

  mounted() {
    this.loading = true;
    this.examId = JSON.parse(sessionStorage.getItem("nowPageData"));
    this.topTitle = this.$route.params.title;
    this.paper_id = this.$route.params.paper_id;
    this.chooseId = this.$route.params.c_id;
    this.model = this.$route.params.model;

    this.init();
   
  },
  methods: {
    init() {
      this.$api.collectTopicList({ paper_id: this.paper_id, model: this.model }).then((res) => {
        if (res.status) {
          this.$nextTick(() => {
            this.questionList = res.data.list;
          });
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
        this.loading = false;
      });
    },
    // 提交事件
    confrimAll(e) {
      // // console.log('提交', e.checkRes);
      this.newList = e.checkRes.newList;
      var tr = e.checkRes;
      var data = {
        type_id: this.type_id,
        param: tr.keyFormat,
        status: 1,
        correct_quantity: tr.correct_quantity,
        errors_quantity: tr.errors_quantity,
      };
      var datas = {
        correct_quantity: tr.correct_quantity,
        errors_quantity: tr.errors_quantity,
        tika: tr.tika,
        allTime: tr.times,
        is_pass: 2, //习题提交
        type_id: this.type_id,
        id: this.id,
        newList: this.newList,
      };
      localStorage.setItem("exercise", JSON.stringify(datas));
      this.$api.questionSubmit(data).then((res) => {
        if (res.status) {
          const { href } = this.$router.resolve({
            name: "viewReport",
            params: {
              datas: "no",
            },
          });

          window.open(href, "_blank");
          // window.close();
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
      });
      // uni.navigateBack({
      // 	delta:1
      // })
    },
    // 答案选择 change 事件
    checkOption(e) {
      // // console.log('check', e);
      // 跳页面
    },
    // 收藏
    starOption(e) {
      let data = {
        topic_id: e.id,
        type_id: this.type_id,
        status: e.is_collect == true ? 1 : 2,
      };
      this.$api.questionCollect(data).then((res) => {
        if (res.status) {
          if (e.is_collect) {
            this.$message({
              message: "收藏成功",
              type: "success",
            });
          } else {
            this.$message({
              message: "移除收藏成功",
              type: "success",
            });
          }
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";
@import "@/assets/css/variable.scss";

::v-deep .el-tree-node__content {
  height: 42px;
}
::v-deep .el-tree-node > .el-tree-node__children {
  height: 52px;
}
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
  // height: 107px;
}
.toExam {
  width: 110px;
  height: 42px;
  border: 1px solid rgba(231, 68, 47, 1);
  color: rgba(231, 68, 47, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
}
.class-item-wrap {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  .class-item {
    width: 296px;
    height: 200px;
    margin-top: 20px;
    margin-bottom: 30px;
    margin-left: 13px;
    cursor: pointer;
    position: relative;
    box-sizing: border-box;
    &:hover {
      box-shadow: 0 15px 20px rgba(0, 0, 0, 0.1);
    }
    // &:first-child {
    //   margin-left: 0;
    // }
    &:nth-child(4n + 1) {
      margin-left: 0;
    }
    .videp-cover {
      width: 296px;
      height: 200px;
    }
    .title {
      position: absolute;
      bottom: 0%;
      left: 0%;
      width: 100%;
      height: 50px;
      background: rgba(49, 44, 44, 0.5);
      text-align: center;
      line-height: 50px;
      color: white;
      font-size: 14px;
    }
  }
}
.exam-box {
  width: 100%;
  height: auto;
  padding: 52px 20px 40px;
  background-color: white;
  box-sizing: border-box;
  .title {
    width: 100%;
    height: 33px;
    line-height: 33px;
    font-size: 24px;
    font-weight: 400;
    text-align: center;
    margin-bottom: 30px;
  }
  .text_prc {
    width: 100%;
    // height: 22px;
    line-height: 22px;
    font-size: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;
    .text_prc_left {
      width: 40%;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: left;
      .text_prc_left_title {
        margin-bottom: 32px;
        height: 22px;
        padding-left: 100px;
      }
    }
  }
}
.class-list {
  // background: #ffffff;
  width: 1226px;
  margin: 20px auto 0;
  // padding: 30px;
  margin-bottom: 20px;
  box-sizing: border-box;
}
.class-title {
  color: #333333;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  span {
    display: inline-block;
    width: 6px;
    height: 38px;
    background: #ff6d6d;
    border-radius: 4px;
    margin-right: 7px;
  }
  .title-wrap {
    display: flex;
    align-items: center;
  }
}
.tr-foot {
  display: flex;
  // position: absolute;
  justify-content: center;
  margin-bottom: 40px;
  .btn {
    height: 45px;
    line-height: 45px;
    font-size: 14px;
    width: 180px;
    text-align: center;
    border: 1px solid $theme-color;
    margin-right: 20px;
    cursor: pointer;
    &.add-btn {
      color: $theme-color;
    }
    &.buy-btn {
      background: $theme-color;
      color: #fff;
    }
    &.sold-out {
      background: $theme-color;
      color: #fff;
      cursor: not-allowed;
      border: none;
    }
    &.disabled {
      background-color: rgb(245, 127, 112);
    }
  }
  .collete-btn {
    min-width: 45px;
    height: 47px;
    text-align: center;
    // padding-top: 5px;
    padding: 5px 5px;
    box-sizing: border-box;
    font-size: 12px;
    background: #fff;
    border: 1px solid $border;
    color: #bebebe;
    cursor: pointer;
    color: $theme-color;
    .icon {
      display: block;
      margin-bottom: 4px;
    }
    &:hover {
      color: $theme-color;
    }
  }
}
</style>
